/* Pikemla Vitals replacement — wishlist (localStorage, no account needed) */
(function () {
  'use strict';
  var KEY = 'pk_wishlist_v1';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function set(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function inList(id) {
    return get().some(function (p) { return String(p.id) === String(id); });
  }

  function paint() {
    document.querySelectorAll('[data-pk-wishlist-toggle]').forEach(function (btn) {
      var on = inList(btn.getAttribute('data-pk-wishlist-toggle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('.pk-wishlist-btn__label');
      if (label) label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('[data-pk-wishlist-count]').forEach(function (el) {
      el.textContent = get().length;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pk-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-pk-wishlist-toggle');
    var list = get();
    if (inList(id)) {
      list = list.filter(function (p) { return String(p.id) !== String(id); });
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-pk-handle'),
        title: btn.getAttribute('data-pk-title')
      });
    }
    set(list);
    paint();
    renderPage();
  });

  function card(p) {
    return fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var img = (j.images && j.images[0]) || '';
        var price = (j.price / 100).toFixed(2);
        return '<div class="pk-wishlist-card">' +
          '<a class="pk-wishlist-card__link" href="/products/' + esc(p.handle) + '">' +
          (img ? '<img class="pk-wishlist-card__img" src="' + esc(img) + '" alt="' + esc(j.title) + '" loading="lazy">' : '') +
          '<span class="pk-wishlist-card__title">' + esc(j.title) + '</span>' +
          '<span class="pk-wishlist-card__price">$' + esc(price) + '</span>' +
          '</a>' +
          '<button type="button" class="pk-wishlist-card__remove" data-pk-wishlist-toggle="' + esc(p.id) + '"' +
          ' data-pk-handle="' + esc(p.handle) + '" aria-label="Remove from wishlist">Remove</button>' +
          '</div>';
      });
  }

  function renderPage() {
    var wrap = document.querySelector('[data-pk-wishlist-page]');
    if (!wrap) return;
    var list = get();
    if (!list.length) {
      wrap.innerHTML = '<p class="pk-wishlist-empty">Your wishlist is empty. Tap the heart on any product to save it here.</p>';
      return;
    }
    wrap.innerHTML = '<p class="pk-wishlist-loading">Loading your wishlist&hellip;</p>';
    Promise.all(list.map(card)).then(function (html) {
      // Re-check: user may have removed everything while loading
      if (!get().length) { renderPage(); return; }
      wrap.innerHTML = html.join('');
      paint();
    }).catch(function () {
      wrap.innerHTML = '<p class="pk-wishlist-empty">Could not load your wishlist. Please try again.</p>';
    });
  }

  function init() { paint(); renderPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
